(()=> {
  const $=(s,c=document)=>c.querySelector(s), $$=(s,c=document)=>[...c.querySelectorAll(s)];
  document.documentElement.classList.remove('no-js');

  // Component-style reveal system.
  const revealIO='IntersectionObserver'in window?new IntersectionObserver(es=>{
    es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('is-visible');revealIO.unobserve(e.target)}})
  },{threshold:.12}):null;
  $$('.reveal,.stagger').forEach(el=>revealIO?revealIO.observe(el):el.classList.add('is-visible'));

  // Luxury atmospheric canvas: particles, gold dust and red light trails.
  class BornToDieScene{
    constructor(canvas){this.c=canvas;this.x=canvas.getContext('2d');this.dpr=Math.min(devicePixelRatio||1,2);this.p=[];this.t=0;this.resize();addEventListener('resize',()=>this.resize());this.seed();this.frame=requestAnimationFrame(()=>this.draw())}
    resize(){this.w=this.c.clientWidth;this.h=this.c.clientHeight;this.c.width=this.w*this.dpr;this.c.height=this.h*this.dpr;this.x.setTransform(this.dpr,0,0,this.dpr,0,0)}
    seed(){const n=Math.min(180,Math.floor(this.w*this.h/8500));this.p=Array.from({length:n},()=>({x:Math.random()*this.w,y:Math.random()*this.h,r:.3+Math.random()*1.2,a:.12+Math.random()*.55,s:.15+Math.random()*.55,ph:Math.random()*Math.PI*2}))}
    draw(){
      const x=this.x,w=this.w,h=this.h;x.clearRect(0,0,w,h);this.t+=.006;
      const g=x.createRadialGradient(w*.5,h*.48,0,w*.5,h*.48,Math.max(w,h)*.58);g.addColorStop(0,'rgba(142,15,24,.16)');g.addColorStop(.35,'rgba(185,154,90,.035)');g.addColorStop(1,'rgba(0,0,0,0)');x.fillStyle=g;x.fillRect(0,0,w,h);
      // Fine gold dust
      for(const p of this.p){p.y-=p.s;if(p.y<-5)p.y=h+5;p.x+=Math.sin(this.t+p.ph)*.12;x.beginPath();x.arc(p.x,p.y,p.r,0,Math.PI*2);x.fillStyle=`rgba(240,210,139,${p.a})`;x.fill()}
      // Two slow elliptical light trails
      x.save();x.translate(w*.5,h*.48);x.rotate(this.t*.22);x.scale(1,.34);x.beginPath();x.arc(0,0,Math.min(w,h)*.34,0,Math.PI*2);x.strokeStyle='rgba(185,154,90,.14)';x.lineWidth=1;x.stroke();x.restore();
      x.save();x.translate(w*.5,h*.48);x.rotate(-this.t*.16+.8);x.scale(.42,1);x.beginPath();x.arc(0,0,Math.min(w,h)*.30,0,Math.PI*2);x.strokeStyle='rgba(197,29,41,.13)';x.lineWidth=1;x.stroke();x.restore();
      this.frame=requestAnimationFrame(()=>this.draw());
    }
  }
  const canvas=$('.lux-canvas');if(canvas&&!matchMedia('(prefers-reduced-motion:reduce)').matches)new BornToDieScene(canvas);

  // Desktop pointer depth.
  if(matchMedia('(pointer:fine)').matches&&!matchMedia('(prefers-reduced-motion:reduce)').matches){
    const hero=$('.hero'),orb=$('.lux-orb');
    hero?.addEventListener('pointermove',e=>{const r=hero.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;if(orb)orb.style.transform=`translate(calc(-50% + ${x*14}px),calc(-50% + ${y*9}px))`});
    hero?.addEventListener('pointerleave',()=>{if(orb)orb.style.transform='translate(-50%,-50%)'});
  }

  // Responsive navigation: mobile drawer + accessible collection dropdown.
  const mobileToggle=$('.mobile-toggle'), mobileNav=$('.mobile-nav');
  mobileToggle?.addEventListener('click',()=>{
    const open=document.body.classList.toggle('mobile-nav-open');
    mobileToggle.setAttribute('aria-expanded',open?'true':'false');
  });
  $$('.mobile-nav a').forEach(a=>a.addEventListener('click',()=>{
    document.body.classList.remove('mobile-nav-open');
    mobileToggle?.setAttribute('aria-expanded','false');
  }));

  $$('.nav-dropdown-toggle').forEach(btn=>{
    const dropdown=btn.closest('.nav-dropdown');
    btn.addEventListener('click',e=>{
      e.stopPropagation();
      const open=dropdown.classList.toggle('is-open');
      btn.setAttribute('aria-expanded',open?'true':'false');
    });
  });
  document.addEventListener('click',e=>{
    $$('.nav-dropdown.is-open').forEach(dropdown=>{
      if(!dropdown.contains(e.target)){
        dropdown.classList.remove('is-open');
        $('.nav-dropdown-toggle',dropdown)?.setAttribute('aria-expanded','false');
      }
    });
  });

  // Product merchandising: real variant data + color swatches + variant media carousel.
  $$('.js-add-to-cart').forEach(form=>{
    const selects=$$('.variant-select',form), idInput=$('.js-variant-id',form), data=$('.js-product-variants',form);
    const gallery=$('[data-product-gallery]');
    const mediaData=gallery?$('.js-product-media',gallery):null;
    if(!idInput||!data)return;
    let variants=[],media=[];
    try{variants=JSON.parse(data.textContent||'[]')}catch(e){variants=[]}
    try{media=JSON.parse(mediaData?.textContent||'[]')}catch(e){media=[]}

    // Add any variant featured media that is not present in product.images.
    variants.forEach(v=>{
      if(!v.media_id||!v.media_preview)return;
      if(!media.some(m=>String(m.id)===String(v.media_id)))media.push({id:v.media_id,src:v.media_src||v.media_preview,preview:v.media_preview,alt:v.media_alt||''});
    });

    const mainImage=$('.js-product-main-image',gallery),counter=$('.js-gallery-counter',gallery);
    let currentMediaIndex=Math.max(0,media.findIndex(m=>String(m.id)===String(gallery?.dataset.currentMediaId)));
    if(currentMediaIndex<0)currentMediaIndex=0;

    const setMediaIndex=(index)=>{
      if(!media.length||!gallery||!mainImage)return;
      currentMediaIndex=(index+media.length)%media.length;
      const item=media[currentMediaIndex];
      mainImage.src=item.preview||item.src;
      mainImage.alt=item.alt||'';
      gallery.dataset.currentMediaId=item.id;
      if(counter)counter.textContent=`${currentMediaIndex+1} / ${media.length}`;
    };

    const setMediaForVariant=(variant)=>{
      if(!variant||!gallery||!mainImage)return;
      if(variant.media_id){
        const index=media.findIndex(m=>String(m.id)===String(variant.media_id));
        if(index>=0){setMediaIndex(index);return;}
      }
      // Robust fallback: Shopify can expose the variant media URL even when its media id
      // is not present in the product image array.
      if(variant.media_preview||variant.media_src){
        mainImage.src=variant.media_preview||variant.media_src;
        mainImage.alt=variant.media_alt||'Product image';
        gallery.dataset.currentMediaId='variant-'+variant.id;
      }
    };

    const updateGalleryControls=()=>{
      const hasMultiple=media.length>1;
      $$('.js-gallery-prev,.js-gallery-next',gallery).forEach(button=>{button.hidden=!hasMultiple});
      if(counter)counter.hidden=!hasMultiple;
    };

    const possibleFor=(index,value)=>variants.some(v=>v.available&&v.options.every((candidate,i)=>{
      if(i===index)return String(candidate)===String(value);
      return !selects[i]||String(selects[i].value)===String(candidate);
    }));

    const syncOptionAvailability=()=>{
      selects.forEach((select,index)=>{
        [...select.options].forEach(option=>{option.disabled=!possibleFor(index,option.value)});
      });
    };

    const colorValueAvailable=(index,value)=>variants.some(v=>v.available&&String(v.options[index]||'')===String(value));
    const syncSwatches=()=>$$('.js-color-swatch').forEach(swatch=>{
      const select=selects.find(s=>s.dataset.optionIndex===swatch.dataset.optionIndex);
      const optionIndex=Number(swatch.dataset.optionIndex),active=select&&String(select.value)===String(swatch.dataset.value);
      swatch.setAttribute('aria-pressed',active?'true':'false');
      swatch.classList.toggle('is-disabled',!colorValueAvailable(optionIndex,swatch.dataset.value));
    });

    const findVariant=()=>{
      const values=selects.map(s=>s.value);
      return variants.find(v=>v.options.every((value,i)=>String(value)===String(values[i])));
    };

    const firstAvailableFor=(index,value)=>variants.find(v=>v.available&&String(v.options[index]||'')===String(value));
    const repairSelection=(changedIndex)=>{
      for(let i=0;i<selects.length;i++){
        if(i===changedIndex)continue;
        const select=selects[i];
        if(!select)continue;
        const exact=variants.some(v=>v.available&&v.options.every((candidate,j)=>String(candidate)===String(selects[j]?.value||'')||j===i));
        if(!exact||!possibleFor(i,select.value)){
          const replacement=[...select.options].find(o=>!o.disabled);
          if(replacement)select.value=replacement.value;
        }
      }
    };

    const syncVariant=(changedIndex=-1)=>{
      if(changedIndex>=0)repairSelection(changedIndex);
      let variant=findVariant();
      if(!variant&&changedIndex>=0){
        const fallback=firstAvailableFor(changedIndex,selects[changedIndex]?.value);
        if(fallback){selects.forEach((s,i)=>s.value=fallback.options[i]);variant=fallback;}
      }
      syncOptionAvailability();syncSwatches();
      const button=$('.add-button',form),price=$('.js-product-price');
      if(!variant){
        idInput.value='';
        if(button){button.disabled=true;button.textContent=window.BT?.i18n?.unavailable||'Unavailable'}
        return;
      }
      idInput.value=variant.id;
      if(price)price.textContent=variant.price_money||'';
      if(button){button.disabled=!variant.available;button.textContent=variant.available?(window.BT?.i18n?.addToBag||'Add to bag'):(window.BT?.i18n?.soldOut||'Sold out')}
      setMediaForVariant(variant);
    };

    selects.forEach((select,index)=>select.addEventListener('change',()=>syncVariant(index)));
    $$('.js-color-swatch').forEach(swatch=>swatch.addEventListener('click',()=>{
      if(swatch.classList.contains('is-disabled'))return;
      const select=selects.find(s=>s.dataset.optionIndex===swatch.dataset.optionIndex);
      if(!select)return;
      select.value=swatch.dataset.value;
      // Update immediately from the color's first available variant, then let the full
      // selector logic reconcile the chosen size without ever showing a stale image.
      const optionIndex=Number(swatch.dataset.optionIndex), preferred=firstAvailableFor(optionIndex,swatch.dataset.value);
      if(preferred){
        selects.forEach((s,i)=>{if(i!==optionIndex)s.value=preferred.options[i]});
      }
      syncVariant(optionIndex);
    }));

    $('.js-gallery-prev',gallery)?.addEventListener('click',()=>setMediaIndex(currentMediaIndex-1));
    $('.js-gallery-next',gallery)?.addEventListener('click',()=>setMediaIndex(currentMediaIndex+1));
    gallery?.addEventListener('keydown',e=>{if(e.key==='ArrowLeft')setMediaIndex(currentMediaIndex-1);if(e.key==='ArrowRight')setMediaIndex(currentMediaIndex+1)});
    let touchStartX=0;gallery?.addEventListener('touchstart',e=>{touchStartX=e.changedTouches[0]?.clientX||0},{passive:true});
    gallery?.addEventListener('touchend',e=>{const endX=e.changedTouches[0]?.clientX||0,diff=endX-touchStartX;if(Math.abs(diff)>45)setMediaIndex(currentMediaIndex+(diff<0?1:-1))},{passive:true});
    updateGalleryControls();setMediaIndex(currentMediaIndex);syncVariant();
    gallery._productMedia={media,getIndex:()=>currentMediaIndex,setIndex:setMediaIndex};
  });

  // Product image lightbox: follows the same active gallery image and variant media.
  const lightbox=$('#ProductLightbox'),lightboxImage=$('.js-lightbox-image',lightbox),gallery=$('[data-product-gallery]');
  let lightboxIndex=gallery?gallery._productMedia?.getIndex?.()||0:0;
  const closeLightbox=()=>{if(!lightbox)return;lightbox.classList.remove('is-open');lightbox.setAttribute('aria-hidden','true');document.body.classList.remove('lightbox-open');if(lightboxImage)lightboxImage.removeAttribute('src')};
  const showLightboxImage=(index)=>{const media=gallery?gallery._productMedia?.media:[];if(!lightbox||!lightboxImage||!media?.length)return;lightboxIndex=(index+media.length)%media.length;const item=media[lightboxIndex];lightboxImage.src=item.src||item.preview||'';lightboxImage.alt=item.alt||'';lightbox.classList.add('is-open');lightbox.setAttribute('aria-hidden','false');document.body.classList.add('lightbox-open')};
  $('.js-product-image',gallery)?.addEventListener('click',()=>showLightboxImage(gallery._productMedia?.getIndex?.()||0));
  $$('.js-lightbox-close').forEach(button=>button.addEventListener('click',closeLightbox));
  $('.js-lightbox-prev',lightbox)?.addEventListener('click',()=>showLightboxImage(lightboxIndex-1));
  $('.js-lightbox-next',lightbox)?.addEventListener('click',()=>showLightboxImage(lightboxIndex+1));

  // Cart drawer using Shopify Ajax API.
  const openCart=()=>document.body.classList.add('cart-open'),closeCart=()=>document.body.classList.remove('cart-open');
  $$('.js-cart-open').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();openCart()}));
  $$('.js-cart-close,.drawer-backdrop').forEach(b=>b.addEventListener('click',closeCart));
  const formatMoney=(c,currency)=>new Intl.NumberFormat(document.documentElement.lang?.startsWith('it')?'it-IT':'en-US',{style:'currency',currency:currency||'EUR'}).format((c||0)/100);
  async function refreshCart(){
    const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});
    if(!r.ok)throw new Error('Cart request failed');
    const cart=await r.json(),count=$('.js-cart-count'),items=$('.js-drawer-items'),total=$('.js-drawer-total');
    if(count)count.textContent=cart.item_count;
    if(items){items.innerHTML=cart.items.length?cart.items.map(i=>`<div class="drawer-item"><img src="${i.image||''}" alt="${i.product_title||''}"><div><h4>${i.product_title||''}</h4>${(i.options_with_values||[]).filter(o=>o.value&&o.value!=='Default Title').map(o=>`<p class="cart-option">${o.name}: ${o.value}</p>`).join('')}${(!i.options_with_values||!i.options_with_values.length)&&i.variant_title&&i.variant_title!=='Default Title'?`<p class="cart-option">${i.variant_title}</p>`:''}<p>${window.BT?.i18n?.quantity||'Qty'} ${i.quantity}</p><p>${formatMoney(i.final_line_price,cart.currency)}</p></div><button class="close-button js-remove" data-key="${i.key}" aria-label="${window.BT?.i18n?.remove||'Remove'}">×</button></div>`).join(''):`<div class="cart-empty"><p class="muted">${window.BT?.i18n?.empty||'Your bag is empty.'}</p></div>`;$$('.js-remove',items).forEach(b=>b.addEventListener('click',async()=>{await fetch(window.BT?.routes?.cartChange||'/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:b.dataset.key,quantity:0})});await refreshCart()}))}
    if(total)total.textContent=formatMoney(cart.total_price,cart.currency);
  }
  $$('.js-add-to-cart').forEach(form=>form.addEventListener('submit',async e=>{
    e.preventDefault();const button=$('.add-button',form);if(button&&button.disabled)return;
    if(button){button.disabled=true;button.dataset.old=button.textContent;button.textContent=(window.BT?.i18n?.adding||'Adding…')}
    try{
      const response=await fetch(window.BT?.routes?.cartAdd||'/cart/add.js',{method:'POST',body:new FormData(form),headers:{Accept:'application/json'}});
      if(!response.ok){const error=await response.json().catch(()=>({}));throw new Error(error.description||window.BT?.i18n?.unavailable||'Unable to add this item')}
      await refreshCart();openCart();
    }catch(err){console.error(err);window.alert(err.message||window.BT?.i18n?.unavailable||'Unable to add this item')}finally{
      if(button){button.disabled=false;button.textContent=button.dataset.old||window.BT?.i18n?.addToBag||'Add to bag'}
      const idInput=$('.js-variant-id',form);if(idInput&&idInput.value){}
    }
  }));
  refreshCart();document.addEventListener('keydown',e=>{if(e.key==='Escape'){closeCart();closeLightbox()}if(lightbox?.classList.contains('is-open')&&e.key==='ArrowLeft')showLightboxImage(lightboxIndex-1);if(lightbox?.classList.contains('is-open')&&e.key==='ArrowRight')showLightboxImage(lightboxIndex+1)});
})();

// Editorial micro-interactions: magnetic CTA + restrained product depth.
if(!matchMedia('(prefers-reduced-motion:reduce)').matches){
  $$('.button--magnetic').forEach(btn=>{
    btn.addEventListener('pointermove',e=>{const r=btn.getBoundingClientRect(),x=e.clientX-r.left-r.width/2,y=e.clientY-r.top-r.height/2;btn.style.transform=`translate(${x*.10}px,${y*.10}px)`});
    btn.addEventListener('pointerleave',()=>btn.style.transform='');
  });
  $$('.product-card').forEach(card=>{
    card.addEventListener('pointermove',e=>{const r=card.getBoundingClientRect(),x=(e.clientX-r.left)/r.width-.5,y=(e.clientY-r.top)/r.height-.5;card.style.setProperty('--mx',`${(x+.5)*100}%`);card.style.setProperty('--my',`${(y+.5)*100}%`);card.style.transform=`perspective(900px) rotateX(${-y*3}deg) rotateY(${x*3}deg) translateY(-3px)`});
    card.addEventListener('pointerleave',()=>{card.style.transform='';});
  });
}
